import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
type ContactAutomationTaskLinkProps = PropsWithChildren & {
  id: number;
};
const ContactAutomationTaskLink = t0 => {
  const $ = _c(3);
  const {
    children,
    id
  } = t0;
  const t1 = `/automation-rules/${id}`;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <LinkWithoutPrefetch className="primary-link w-full whitespace-normal" href={t1} target="__blank">{children}</LinkWithoutPrefetch>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default ContactAutomationTaskLink;